<template>
    <v-dialog max-width="800" v-model="dialog" scrollable :persistent="!hideButtons">
      <v-card>
        <v-card-title class="headline accent">Privacy Policy &amp; Terms of Use</v-card-title>
        <v-card-text>
          <terms-text />
        </v-card-text>
        <v-card-actions v-if="!hideButtons">
          <v-spacer />
          <v-btn color="primary" @click="$emit('selected', true)">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import termsText from './terms-conditions-text';

export default {
  props: {
    value: {
      type: Boolean,
    },
    hideButtons: {
      type: Boolean,
    },
  },
  components: { termsText },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
